import { render, staticRenderFns } from "./ThankyouPage.vue?vue&type=template&id=2832c8d9&scoped=true&"
import script from "./ThankyouPage.vue?vue&type=script&lang=js&"
export * from "./ThankyouPage.vue?vue&type=script&lang=js&"
import style0 from "./ThankyouPage.vue?vue&type=style&index=0&id=2832c8d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832c8d9",
  null
  
)

export default component.exports